// Style-related variables
import Color from 'color';


export function px(p) {
  return `${Math.round(p) / 16}rem`;
}

export const pageWidth = px(1680);

export function fade(color, amount) {
  return Color(color)
    .fade(amount)
    .string();
}

export const colors = {
  black: '#000',
  nightTime: '#212119', // e.g. 'black' borders within the design, 'black' text.
  darkGray: '#4A4A4A', // e.g. ruler tick marks
  pigeonGray: '#6B6D70', // or use the more conventional 707070
  gray: '#AEAEAE', // e.g. dividers in left hand menu on design page, ruler borders(was keyword gray)
  doveGray: '#A7A49B', // e.g. Disabled Text on design page.
  altoMockingbirdGray: '#d8d8d8', // ha!
  lightGray: '#F3F3F3', // e.g. canvas on design page.
  dayTime: '#F9F9F9', // e.g. menus and palettes
  whiteTern: '#FCFCFC', // experimental for when almost white is better than white.
  newsprint: '#eceee9',
  white: '#fff',
  safetyLemon: '#e3dc22',
  exoticPlum: '#c235ab',
  palePlum: '#b36e8e',
  midGray: '#999',
  paleSky: '#f5f5fa',
  blue: '#1eb9e1',
  slateBlue: '#4070ae',
  fiestaRed: '#dd4832',
  salmon: '#f5bd8b',
  navy: '#263d4f',
  paleGreen: '#9fb450',
  pink: '#e4a89f',
  paleBlue: '#a1b8d0',
  lavender: '#93abd9',
  beige: '#afa788',
  warmBeige: '#fff4e5',
  sage: '#63a589',
  creamsicle: '#ffaf56',
  success: '#55b87c',
  failure: '#ff543f',
  warning: '#f19830',
};

// URW DIN font family
export const roboto = [
  'Roboto',
  'Helvetica',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
].join(',');

export const trirong = [
  '"Trirong"',
  '"Times New Roman"',
  'Times',
  'serif',
].join(',');

export const founders = [
  '"Founders Grotesk"',
  '"Roboto"',
  'Helvetica',
  'Arial',
  'sans-serif',
].join(',');


// Responsive breakpoints
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const keys = ['xs', 'sm', 'md', 'lg', 'xl'];

// Keep in mind that @media is inclusive by the CSS specification.
function createBreakpoints(breakpoints) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm[.
    values = {
      xs: 0,
      sm: 600,
      md: 768,
      lg: 1088,
      xl: 1280,
    },
    unit = 'px',
    step = 5,
    ...other
  } = breakpoints;

  function up(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (min-width:${value}${unit})`;
  }

  function down(key) {
    const endIndex = keys.indexOf(key) + 1;
    const upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    const value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return `@media (max-width:${value - step / 100}${unit})`;
  }

  function between(start, end) {
    const endIndex = keys.indexOf(end) + 1;

    if (endIndex === keys.length) {
      return up(start);
    }

    return (
      `@media (min-width:${values[start]}${unit}) and ` +
      `(max-width:${values[keys[endIndex]] - step / 100}${unit})`
    );
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return {
    keys,
    values,
    up,
    down,
    between,
    only,
    width,
    ...other,
  };
}

export const breakpoints = createBreakpoints({});
